export interface ResolveActivateSubscriptionIdArgs {
  activeMenuSubscriptionId?: string | null
  subscriptionMatchId?: string | null
  subscriptions?: Array<{ id: string; status: string }> | null
}

export function resolveActivateSubscriptionId(args: ResolveActivateSubscriptionIdArgs): string | null {
  const { activeMenuSubscriptionId, subscriptionMatchId, subscriptions } = args
  const id =
    activeMenuSubscriptionId ??
    subscriptionMatchId ??
    subscriptions?.find((s) => s.status !== 'ACTIVE')?.id ??
    subscriptions?.[0]?.id ??
    null
  return id && String(id).trim() ? id : null
}

export const ACTIVATE_RECOVERY_PATH = '/meal-kit/plans'
export const ACTIVATE_NO_PLAN_MESSAGE =
  'Unable to find your plan. Please go to Meal Kit plans to reactivate.'

export function logActivateBlockedMissingId(entryPoint: string): void {
  console.warn(`[ActivateSubscription] blocked at ${entryPoint}: no subscription ID resolved`)
}

export function logActivateRequestSent(entryPoint: string, idPresent: boolean): void {
  console.log(`[ActivateSubscription] sent from ${entryPoint}, id present: ${idPresent}`)
}
